import React from "react";
import direction from "../../service/direction.json";
const Logo = () => {
  return (
    <div className="input-group">
      <div style={{ fontSize: "15px" }} className="text-center">
        S
        <img
          src={`${direction.ImgDesign}pngwing.com.png`}
          style={{ width: "32px", height: "32px" }}
          alt="سایه بان"
        />
        S
      </div>
      <div style={{ fontSize: "13px" }} className="text-center">
        سامانه پیام کوتاه
        <br /> سایه بانــــــــ
      </div>
    </div>
  );
};

export default Logo;
